"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslations } from "next-intl";

export const FAQSection = () => {
  const t = useTranslations("FAQ");

  // Define FAQ items with their translation keys
  const faqItems = [
    {
      value: "accuracy",
      questionKey: "questions.accuracy.q",
      answerKey: "questions.accuracy.a",
    },
    {
      value: "editing",
      questionKey: "questions.editing.q",
      answerKey: "questions.editing.a",
    },
    {
      value: "credits",
      questionKey: "questions.credits.q",
      answerKey: "questions.credits.a",
    },
    {
      value: "formats",
      questionKey: "questions.formats.q",
      answerKey: "questions.formats.a",
    },
    {
      value: "languages",
      questionKey: "questions.languages.q",
      answerKey: "questions.languages.a",
    },
    {
      value: "print",
      questionKey: "questions.print.q",
      answerKey: "questions.print.a",
    },
    {
      value: "features",
      questionKey: "questions.features.q",
      answerKey: "questions.features.a",
    },
  ];

  return (
    <section
      id="faq"
      className="container mx-auto px-4 py-16 md:py-24 relative"
      aria-labelledby="faq-heading"
    >
      <div
        className="absolute left-0 top-1/4 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl -z-10 opacity-40"
        aria-hidden="true"
      ></div>
      <div
        className="absolute right-0 bottom-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl -z-10 opacity-30"
        aria-hidden="true"
      ></div>

      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <h2
            id="faq-heading"
            className="text-3xl md:text-4xl font-display font-[650] tracking-tight mb-4"
          >
            {t("title")}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8 font-sans">
            {t("subtitle")}
          </p>
          <div
            className="w-24 h-1 bg-gradient-to-r from-transparent via-primary/50 to-transparent mx-auto"
            aria-hidden="true"
          ></div>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqItems.map((faq) => (
            <AccordionItem
              key={faq.value}
              value={faq.value}
              className="border-b border-border py-2"
            >
              <AccordionTrigger className="text-left text-lg font-medium hover:text-primary transition-colors py-4 font-display">
                {t(faq.questionKey)}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-4 font-sans">
                {t(faq.answerKey)}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
